<template>
  <div class="content">
    <div class="filter f-b-c">
      <el-input placeholder="请输入专辑名称" v-model="listParams.name" style="width:350px">
        <el-button slot="append" icon="el-icon-search" @click="handleCurrentChange(1)"></el-button>
      </el-input>
      <div>
        <el-button size="medium" type="primary" round @click="addAlbum">创建专辑</el-button>
        <el-button size="medium" type="primary" round @click="showHandle">首页合集排序</el-button>
        <el-button size="medium" type="primary" :disabled="!moduleIds.length"  round @click="exportProductModule(20)">导出</el-button>
      </div>
    </div>

    <el-table v-loading="loading" :data="albumList" height="calc(100vh - 198px)" row-key="id" :tree-props="{children: 'childList'}" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="moduleId" label="专辑ID"></el-table-column>
      <el-table-column prop="name" label="专辑名称"></el-table-column>
      <el-table-column label="首页显示">
        <template slot-scope="{ row }">
          <div>{{  row.showStatus ? '是' : '否'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="优先级"></el-table-column>
      <el-table-column prop="num" label="商品数量"></el-table-column>
      <!-- <el-table-column prop="linkUrl" label="专辑链接"></el-table-column> -->
      <el-table-column prop="modifier" label="最后更新人"></el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="{ row }">
          <div>{{ row.createDate | dateFormat}}</div>
        </template>
      </el-table-column>
      <el-table-column label="最后更新时间">
        <template slot-scope="{ row }">
          <div>{{ row.modifyDate | dateFormat}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px">
        <template slot-scope="scope">
          <el-button type="text" @click="editAlbum(scope.row)" style="margin-right: 10px;">编辑</el-button>
          <el-popconfirm v-if="!scope.row.type" title="是否确定删除此专辑？" @confirm="deleteAlbum(scope.row)">
            <el-button type="text" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="f-b-c bg-white" style="padding: 12px">
      <div></div>
      <el-pagination background :current-page="listParams.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <album-show-list ref="albumShowList" />
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import albumShowList from './components/albumShowList.vue'

export default {
  name: 'supply_album',
  components: { albumShowList },
  data() {
    return {
      albumList: [],
      moduleIds: [], // 表格复选框当前选中行的专辑id数组
      listParams: {
        pageSize: 20,
        pageNumber: 1
      },
      total: 0,
      loading: false,
      sortList: []
    }
  },
  created() {
    this.getAlbumModuleList()
  },
  methods:{
    handleCurrentChange(page) {
      this.listParams.pageNumber = page
      this.getAlbumModuleList()
    },
    // 每页显示条数发生改变时的回调
    handleSizeChange(size) {
      this.listParams.pageSize = size
      this.getAlbumModuleList()
    },
    addAlbum() {
      this.$router.push('/supply/album/add')
    },
    deleteAlbum(row) {
      API.deleteAlbumModule(row.id).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success('删除成功')
        this.handleCurrentChange(1)
      })
    },
    editAlbum(row) {
      this.$router.push({ path: '/supply/album/add', query: { id: row.id, albumType: row.type }})
    },

    getAlbumModuleList() {
      API.getAlbumModuleList(this.listParams).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.albumList = res.data.list
        this.total = res.data.total
      })
    },

    showHandle() {
      this.$refs.albumShowList.show()
    },
    // 当表格复选框选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
      this.moduleIds = selection.map((item) => item.moduleId)
    },
    // 导出产品专辑数据
    async exportProductModule(taskType) {
      let newParameter = { ...this.parameter, moduleIds: this.moduleIds }
      newParameter.searchNameArrays = newParameter.searchNameArrays ? (newParameter.searchNameArrays.includes(',') ? newParameter.searchNameArrays.split(',') : newParameter.searchNameArrays.split('\n')) : undefined
      delete newParameter.pageNumber
      delete newParameter.pageSize
      let taskTypeType = Object.prototype.toString.call(taskType).slice(8, -1)
      API.importExportFile({ fileType: 2, taskType: taskTypeType === 'Number' ? taskType : 4, condition: JSON.stringify(newParameter) }).then(() => {
        this.$message.success('产品专辑数据导出成功,请前往导入导出中心查看进度')
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.content{
  height: 100%;
  background: white;
  min-width: 1200px;
  .filter{
    padding: 12px;
  }
}
</style>